var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#67728B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.888 3.849l-.23.235c-.071.073-.167.113-.27.113-.103 0-.199-.04-.27-.113L3.501 1.426l-2.62 2.66C.812 4.16.716 4.2.613 4.2c-.102 0-.199-.04-.27-.114l-.23-.233c-.15-.151-.15-.398 0-.55L3.23.125C3.302.052 3.398 0 3.5 0h.002c.102 0 .198.052.27.125l3.115 3.17c.072.073.112.173.112.278 0 .104-.04.203-.112.276zM6.888 7.351l-.23-.235c-.071-.073-.167-.113-.27-.113-.103 0-.199.04-.27.113L3.501 9.774l-2.62-2.66C.812 7.04.716 7 .613 7c-.102 0-.199.04-.27.114l-.23.233c-.15.151-.15.398 0 .55l3.118 3.178c.072.073.168.125.271.125h.002c.102 0 .198-.052.27-.125l3.115-3.17C6.96 7.832 7 7.732 7 7.627c0-.104-.04-.203-.112-.276z",
    transform: "translate(0 .575)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.f5c6903b.svg";
export { ForwardRef as ReactComponent };